<p-dialog [(visible)]="displayEditViewDialog" [modal]="true" [closable]="false" [responsive]="true"
[style]="{width: '85vw'}" styleClass="add-edit-account" appendTo="body">
    <ng-template pTemplate="header">
        <h5 class="p-mb-0">Edit Account</h5>
    </ng-template>

    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
                {{ displayView ? 'Account 360 View' : 'Edit Account' }}
            </h5>
            <div class="p-ml-auto p-d-flex p-ai-center">
                <div *ngIf="displayView && viewAccountData" class="p-mr-2">
                    <strong> Created by {{ viewAccountData?.createdByUserName }}</strong> {{ viewAccountData?.createdDate | localDate: 'date' }}
                </div>
                <button pButton pRipple *ngIf="displayView && editPermission && selectedAccount && selectedAccount?.statusId == 1"
                        (click)="displayView=false" style="margin-left: auto;" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-pencil">
                </button>
                <button pButton pRipple (click)="closeModal.emit()" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times">
                </button>
            </div>

        </div>
    </ng-template>

    <ng-container *ngIf="!displayView">
        <div *ngIf="templateSections.length; else elseBlock">
            <div>
                <form [formGroup]="accountForm" autocomplete="off">
                    <div class="header">
                        <h5>
                            {{ templateSections && templateSections[0]?.name }}
                        </h5>
                    </div>
                    <div class="card">
                        <div formArrayName="accountContacts">
                            <ng-container *ngFor="let contact of formControl.accountContacts?.controls; let i = index;">
                                <ng-container [formGroup]="contact">
                                    <ng-container formGroupName="contact">
                                        <div class="p-field p-grid">
                                            <div class="p-col-12 p-lg-2" *ngIf="checkedFields.Title">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.Title?.labelName }}
                                                    @if(checkedFields.Title?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                                        pTooltip="{{checkedFields.Title?.description}}" 
                                                        tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <p-dropdown [options]="salutations" name="title" optionLabel="name" dataKey="id" formControlName="salutation" placeholder="Select Title" appendTo="body">
                                                </p-dropdown>
                                            </div>

                                            <div class="p-col-12 p-formgrid  p-lg-4">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.FirstName?.labelName }}
                                                    <span style="color: red;">
                                                        *
                                                    </span>
                                                    @if(checkedFields.FirstName?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                                        pTooltip="{{checkedFields.FirstName?.description}}" 
                                                        tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <input pInputText type="text" formControlName="firstName" name="firstName" />
                                                <div class="p-mt-1">
                                                    <small id="error-help" class="p-invalid"
                                                        *ngIf="formControl?.contact?.get('firstName')?.errors?.required && formControl?.contact?.get('firstName').touched">
                                                        First name is required
                                                    </small>
                                                    <small *ngIf="hasMaxLengthErrorContact('firstName', 100)"
                                                        class="p-invalid">
                                                        Max 100 characters
                                                    </small>
                                                    <small id="error-help" class="p-invalid"
                                                        *ngIf="formControl?.contact?.get('firstName')?.errors?.pattern && formControl?.contact?.get('firstName').touched">
                                                        Colon (:) is not allowed
                                                    </small>
                                                </div>
                                            </div>

                                            <div class="p-col-12 p-lg-2" *ngIf="checkedFields.MiddleInitial">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.MiddleInitial?.labelName }}
                                                    @if(checkedFields.MiddleInitial?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                                        pTooltip="{{checkedFields.MiddleInitial?.description}}" 
                                                        tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <input pInputText type="text" formControlName="middleName" />
                                                <div class="p-mt-1">
                                                    <small *ngIf="hasMaxLengthErrorContact('middleName', 100)"
                                                        class="p-invalid">
                                                        Max 100 characters
                                                    </small>
                                                     <small id="error-help" class="p-invalid"
                                                        *ngIf="formControl?.contact?.get('middleName')?.errors?.pattern && formControl?.contact?.get('middleName').touched">
                                                        Colon (:) is not allowed
                                                    </small>
                                                </div>
                                            </div>

                                            <div class="p-col-12 p-lg-4" *ngIf="checkedFields.LastName">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.LastName?.labelName }}
                                                    @if(checkedFields.LastName?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                                        pTooltip="{{checkedFields.LastName?.description}}" 
                                                        tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <input pInputText type="text" formControlName="lastName" id="lastName" name="lastName" />
                                                <div class="p-mt-1">
                                                    <small *ngIf="hasMaxLengthErrorContact('lastName', 100)"
                                                        class="p-invalid">
                                                        Max 100 characters
                                                    </small>
                                                    <small id="error-help" class="p-invalid"
                                                        *ngIf="formControl?.contact?.get('lastName')?.errors?.pattern && formControl?.contact?.get('lastName').touched">
                                                        Colon (:) is not allowed
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="p-field p-formgrid p-grid multiline">
                                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.WorkEmail || checkedFields.HomeEmail ||
                                            checkedFields.CE1 || checkedFields.CE2">
                                                <div class="p-inputgroup p-grid p-mb-2">
                                                    <label class="p-col-12">
                                                        Email
                                                        @if(checkedFields.WorkEmail || checkedFields.HomeEmail ||
                                                        checkedFields.CE1 || checkedFields.CE2){
                                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                                   pTooltip="Primary contact email address."
                                                                   tooltipPosition="top">
                                                                </i>
                                                            }
                                                    </label>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.WorkEmail">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.WorkEmail?.labelName"
                                                                tooltipPosition="top" class="pi pi-briefcase">
                                                            </i>
                                                            <input pInputText type="email" #workemail="ngModel"
                                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                                [(ngModel)]="workEmail.tempValue"
                                                                [accountId]="accountForm.value?.id" [leadId]="accountForm.value?.leadId"
                                                                [asyncEmailValidator]="accountEmails[0]?.email?.emailAddress"
                                                                (blur)="contactEmailCheck(workEmail,workemail)"
                                                                [ngModelOptions]="{standalone: true}" />
                                                        </span>
                                                    </div>
                                                    <div class="p-pl-2 p-mt-2"
                                                    *ngIf="workEmail.tempValue?.length > 100 || workemail?.errors?.pattern || workemail.errors?.emailExists">
                                                        <div *ngIf="workEmail.tempValue?.length > 100">
                                                            <small class="p-invalid">
                                                                Max 100 characters
                                                            </small>
                                                        </div>
                                                        <div *ngIf="workemail?.errors?.pattern">
                                                            <small class="p-invalid">
                                                                Invalid email format
                                                            </small>
                                                        </div>
                                                        <div *ngIf="workemail.errors?.emailExists">
                                                            <small class="p-invalid">
                                                                This email already added, please enter another email
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.HomeEmail">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.HomeEmail?.labelName"
                                                                tooltipPosition="top" class="pi pi-home">
                                                            </i>
                                                            <input pInputText type="email" #homeemail="ngModel"
                                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                                [(ngModel)]="homeEmail.tempValue"
                                                                [accountId]="accountForm.value?.id" [leadId]="accountForm.value?.leadId"
                                                                [asyncEmailValidator]="accountEmails[0]?.email?.emailAddress||workEmail?.tempValue"
                                                                (blur)="contactEmailCheck(homeEmail,homeemail)"
                                                                [ngModelOptions]="{standalone: true}" />
                                                        </span>
                                                    </div>
                                                    <div class="p-pl-2 p-mt-2"
                                                    *ngIf="homeEmail.tempValue?.length > 100 || homeemail?.errors?.pattern || homeemail.errors?.emailExists">
                                                        <div *ngIf="homeEmail.tempValue?.length > 100">
                                                            <small class="p-invalid">
                                                                Max 100 characters
                                                            </small>
                                                        </div>
                                                        <div *ngIf="homeemail?.errors?.pattern">
                                                            <small class="p-invalid">
                                                                Invalid email format
                                                            </small>
                                                        </div>
                                                        <div *ngIf="homeemail.errors?.emailExists">
                                                            <small class="p-invalid">
                                                                This email already added, please enter another email
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.CE1">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.CE1?.labelName"
                                                                tooltipPosition="top" class="pi pi-envelope">
                                                            </i>
                                                            <input pInputText type="email" #ceone="ngModel"
                                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                                [(ngModel)]="ce1.tempValue"
                                                                (blur)="contactEmailCheck(ce1,ceone)"
                                                                [ngModelOptions]="{standalone: true}" />
                                                        </span>
                                                    </div>
                                                    <div class="p-pl-2 p-mt-2"
                                                    *ngIf="ce1.tempValue?.length > 100 || ceone?.invalid">
                                                        <div *ngIf="ce1.tempValue?.length > 100">
                                                            <small class="p-invalid">
                                                                Max 100 characters
                                                            </small>
                                                        </div>
                                                        <div *ngIf="ceone?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid email format
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.CE2">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.CE2?.labelName"
                                                                tooltipPosition="top" class="pi pi-envelope">
                                                            </i>
                                                            <input pInputText type="email" #cetwo="ngModel"
                                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                                [(ngModel)]="ce2.tempValue"
                                                                (blur)="contactEmailCheck(ce2,cetwo)"
                                                                [ngModelOptions]="{standalone: true}" />
                                                        </span>
                                                    </div>
                                                    <div class="p-pl-2 p-mt-2"
                                                    *ngIf="ce2.tempValue?.length > 100 || cetwo?.invalid">
                                                        <div *ngIf="ce2.tempValue?.length > 100">
                                                            <small class="p-invalid">
                                                                Max 100 characters
                                                            </small>
                                                        </div>
                                                        <div *ngIf="cetwo?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid email format
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.WorkPhone || checkedFields.HomePhone ||
                                            checkedFields.MobilePhone || checkedFields.CP1 || checkedFields.CP2">
                                                <div class="p-inputgroup p-grid p-mb-2">
                                                    <label class="p-col-4">
                                                        Select Country
                                                    </label>
                                                    <label class="p-col-8" style="padding-left:0.75rem">
                                                        Phone
                                                        @if(checkedFields.WorkPhone || checkedFields.HomePhone ||
                                                        checkedFields.MobilePhone || checkedFields.CP1 || checkedFields.CP2){
                                                                        <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                                           pTooltip="Primary contact phone number"
                                                                           tooltipPosition="top">
                                                                        </i>
                                                                    }
                                                    </label>
                                                </div>
                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.WorkPhone">
                                                    <div class="p-col-12 p-lg-4 ">
                                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                            optionLabel="CountryName"
                                                            optionValue="CountryName"
                                                            [autoDisplayFirst]="false"
                                                            [ngModelOptions]="{standalone:true}"
                                                            [(ngModel)]="workPhone.phone.country"
                                                            placeholder="Select Country"
                                                            (onChange)="onCountrySelect($event, workPhone)"
                                                            class="inline custom-height" appendTo="body">
                                                        </p-dropdown>
                                                    </div>
                                                    <div class="p-col-12  p-lg-8">
                                                        <div class="p-inputgroup">
                                                            <span class="p-inputgroup-addon">+{{workPhone.phone.code}}</span>
                                                            <p-inputMask *ngIf="phoneNumberFormat && !workPhone?.phone?.maskingDisabled"  [mask]="phoneNumberFormat"  #workPhonen="ngModel" [(ngModel)]="workPhone.tempValue"
                                                            [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false"
                                                            placeholder="{{checkedFields.WorkPhone.labelName}}" class="w-100"
                                                            pTooltip="{{checkedFields.WorkPhone.labelName}}" tooltipPosition="top"></p-inputMask>
                                                            <input *ngIf="!(phoneNumberFormat && !workPhone?.phone?.maskingDisabled)" pInputText type="text" [(ngModel)]="workPhone.tempValue"
                                                            #workphone="ngModel"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.WorkPhone.labelName}}"
                                                            pTooltip="{{checkedFields.WorkPhone.labelName}}" tooltipPosition="top" />
                                                        </div>

                                                    </div>
                                                    <div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="workphone?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid phone format
                                                            </small>
                                                        </div>
                                                        <div class="p-pl-1 p-mt-1"
                                                            *ngIf="workPhone.tempValue | phoneValidation">
                                                            <small class="p-invalid">
                                                                Max 50 characters
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.HomePhone">
                                                    <div class="p-col-12 p-lg-4">
                                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                            optionLabel="CountryName"
                                                            optionValue="CountryName"
                                                            [autoDisplayFirst]="false"
                                                            [ngModelOptions]="{standalone:true}"
                                                            [(ngModel)]="homePhone.phone.country"
                                                            placeholder="Select Country"
                                                            (onChange)="onCountrySelect($event, homePhone)"
                                                            class="inline custom-height" appendTo="body">
                                                        </p-dropdown>
                                                    </div>
                                                    <div class="p-col-12 p-lg-8">
                                                        <div class="p-inputgroup">
                                                            <span class="p-inputgroup-addon">+{{homePhone.phone.code}}</span>
                                                            <p-inputMask *ngIf="phoneNumberFormat && !homePhone?.phone?.maskingDisabled"  [mask]="phoneNumberFormat"  type="text"  #homePhonen="ngModel" [(ngModel)]="homePhone.tempValue"
                                                            [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false"
                                                            placeholder="{{checkedFields.HomePhone.labelName}}" class="w-100"
                                                            pTooltip="{{checkedFields.HomePhone.labelName}}" tooltipPosition="top"></p-inputMask>
                                                            <input *ngIf="!(phoneNumberFormat && !homePhone?.phone?.maskingDisabled)" pInputText type="text" #homephone="ngModel"
                                                            [(ngModel)]="homePhone.tempValue"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.HomePhone.labelName}}"
                                                            pTooltip="{{checkedFields.HomePhone.labelName}}" tooltipPosition="top" />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="homephone?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid phone format
                                                            </small>
                                                        </div>
                                                        <div class="p-pl-1 p-mt-1"
                                                            *ngIf="homePhone.tempValue | phoneValidation">
                                                            <small class="p-invalid">
                                                                Max 50 characters
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.MobilePhone">
                                                    <div class="p-col-12 p-lg-4 ">
                                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="mobilePhone.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, mobilePhone)"
                                                        class="inline custom-height" appendTo="body">
                                                        </p-dropdown>
                                                    </div>
                                                    <div class="p-col-12 p-lg-8">
                                                        <div class="p-inputgroup">
                                                            <span class="p-inputgroup-addon">+{{mobilePhone.phone.code}}</span>
                                                            <p-inputMask *ngIf="phoneNumberFormat && !mobilePhone?.phone?.maskingDisabled"  [mask]="phoneNumberFormat"  type="text"  #mobilePhonen="ngModel" [(ngModel)]="mobilePhone.tempValue"
                                                            [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false"
                                                            placeholder="{{checkedFields.MobilePhone.labelName}}" class="w-100"
                                                            pTooltip="{{checkedFields.MobilePhone.labelName}}" tooltipPosition="top"></p-inputMask>

                                                            <input *ngIf="!(phoneNumberFormat && !mobilePhone?.phone?.maskingDisabled)"  pInputText type="text" #mobilephone="ngModel"
                                                            [(ngModel)]="mobilePhone.tempValue"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.MobilePhone.labelName}}"
                                                            pTooltip="{{checkedFields.MobilePhone.labelName}}" tooltipPosition="top"/>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="mobilephone?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid phone format
                                                            </small>
                                                        </div>
                                                        <div class="p-pl-1 p-mt-1"
                                                            *ngIf="mobilePhone.tempValue | phoneValidation">
                                                            <small class="p-invalid">
                                                                Max 50 characters
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.CP1">
                                                    <div class="p-col-12 p-lg-4">
                                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="cp1.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, cp1)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{cp1.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !cp1?.phone?.maskingDisabled"  [mask]="phoneNumberFormat"  type="text"  #cpone="ngModel" [(ngModel)]="cp1.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false"
                                                        placeholder="{{checkedFields.CP1.labelName}}" class="w-100"
                                                        pTooltip="{{checkedFields.CP1.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input *ngIf="!(phoneNumberFormat && !cp1?.phone?.maskingDisabled)"  pInputText type="text" [(ngModel)]="cp1.tempValue"
                                                        [ngModelOptions]="{standalone: true}" #cpone="ngModel" placeholder="{{checkedFields.CP1.labelName}}"
                                                        pTooltip="{{checkedFields.CP1.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                </div>
                                                    <div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="cpone?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid phone format
                                                            </small>
                                                        </div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="cp1.tempValue | phoneValidation">
                                                            <small class="p-invalid">
                                                                Max 50 characters
                                                            </small>
                                                        </div>
                                                        </div>
                                                    </div>

                                                <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.CP2">
                                                    <div class="p-col-12  p-lg-4 ">
                                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="cp2.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, cp2)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{cp2.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !cp2?.phone?.maskingDisabled"  [mask]="phoneNumberFormat"  type="text"  #cptwo="ngModel" [(ngModel)]="cp2.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false"
                                                        placeholder="{{checkedFields.CP2.labelName}}" class="w-100"
                                                        pTooltip="{{checkedFields.CP2.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input  *ngIf="!(phoneNumberFormat && !cp2?.phone?.maskingDisabled)" pInputText type="text" [(ngModel)]="cp2.tempValue"
                                                        [ngModelOptions]="{standalone: true}" #cptwo="ngModel"
                                                        placeholder="{{checkedFields.CP2.labelName}}"
                                                        pTooltip="{{checkedFields.CP2.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                </div>
                                                    <div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="cptwo?.invalid">
                                                            <small class="p-invalid">
                                                                Invalid phone format
                                                            </small>
                                                        </div>
                                                        <div class="p-pl-1 p-mt-1" *ngIf="cp2.tempValue | phoneValidation">
                                                            <small class="p-invalid">
                                                                Max 50 characters
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <ng-container>
                                            <div class="p-field p-formgrid p-grid multiline">
                                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ContactTwitter ||
                                                    checkedFields.ContactFacebook || checkedFields.ContactLinkedin ||
                                                    checkedFields.ContactInstagram || checkedFields.ContactWebsite">
                                                    <div class="p-inputgroup p-mb-2">
                                                        <label style="width: 100%;">
                                                            Social Profile
                                                        </label>
                                                    </div>

                                                    <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.ContactTwitter">
                                                        <div class="p-col-12">
                                                            <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                                <i [pTooltip]="checkedFields.ContactTwitter?.labelName"
                                                                    tooltipPosition="top" class="fa fa-twitter">
                                                                </i>
                                                                <input pInputText type="text"
                                                                    [(ngModel)]="contactTwitter.tempValue"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                            </span>
                                                        </div>
                                                        <div class="p-mt-2" *ngIf="contactTwitter?.tempValue?.length">
                                                            <small class="p-invalid p-pl-2" *ngIf="contactTwitter?.tempValue?.length > 500">
                                                                Max 500 characters
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.ContactFacebook">
                                                        <div class="p-col-12">
                                                            <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                                <i [pTooltip]="checkedFields.ContactFacebook?.labelName"
                                                                    tooltipPosition="top" class="fa fa-facebook-official">
                                                                </i>
                                                                <input pInputText type="text"
                                                                    [(ngModel)]="contactFacebook.tempValue"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                            </span>
                                                        </div>
                                                        <div class="p-mt-2" *ngIf="contactFacebook?.tempValue?.length">
                                                            <small class="p-invalid p-pl-2" *ngIf="contactFacebook?.tempValue?.length > 500">
                                                                Max 500 characters
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.ContactLinkedin">
                                                        <div class="p-col-12">
                                                            <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                                <i [pTooltip]="checkedFields.ContactLinkedin?.labelName"
                                                                    tooltipPosition="top" class="fa fa-linkedin">
                                                                </i>
                                                                <input pInputText type="text"
                                                                    [(ngModel)]="contactLinkedin.tempValue"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                            </span>
                                                        </div>
                                                        <div class="p-mt-2" *ngIf="contactLinkedin?.tempValue?.length">
                                                            <small class="p-invalid p-pl-2" *ngIf="contactLinkedin?.tempValue?.length > 500">
                                                                Max 500 characters
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.ContactInstagram">
                                                        <div class="p-col-12">
                                                            <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                                <i [pTooltip]="checkedFields.ContactInstagram?.labelName"
                                                                    tooltipPosition="top" class="fa fa-instagram">
                                                                </i>
                                                                <input pInputText type="text"
                                                                    [(ngModel)]="contactInstagram.tempValue"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                            </span>
                                                        </div>
                                                        <div class="p-mt-2" *ngIf="contactInstagram?.tempValue?.length">
                                                            <small class="p-invalid p-pl-2" *ngIf="contactInstagram?.tempValue?.length > 500">
                                                                Max 500 characters
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div class="p-grid p-field p-formgrid" *ngIf="checkedFields.ContactWebsite">
                                                        <div class="p-col-12">
                                                            <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                                <i [pTooltip]="checkedFields.ContactWebsite?.labelName"
                                                                    tooltipPosition="top" class="fa fa-desktop">
                                                                </i>
                                                                <input pInputText type="text"
                                                                    [(ngModel)]="contactWebsite.tempValue"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                            </span>
                                                        </div>
                                                        <div class="p-mt-2" *ngIf="contactWebsite?.tempValue?.length">
                                                            <small class="p-invalid p-pl-2" *ngIf="contactWebsite?.tempValue?.length > 500">
                                                                Max 500 characters
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ProfileImage">
                                                    <div class="p-grid">
                                                        <div class="p-col-12">
                                                            <label class="p-mb-2">
                                                                {{ checkedFields.ProfileImage?.labelName }}
                                                                @if(checkedFields?.ProfileImage.description){
                                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                                       pTooltip="{{checkedFields.ProfileImage?.description}}"
                                                                       tooltipPosition="top">
                                                                    </i>
                                                                }
                                                            </label>
                                                            <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose" accept="image/*" [showUploadButton]="false" [showCancelButton]="false" (onSelect)="uploadProfilePic($event.files)">
                                                                <ng-template pTemplate="file"></ng-template>
                                                                <ng-template pTemplate="content">
                                                                    <ng-container *ngIf="selectedcontactProfileImages">
                                                                        <ng-container *ngFor="let profileImg of selectedcontactProfileImages;
                                                                                let i = index;">
                                                                            <ng-container *ngIf="profileImg.attachment && profileImg.attachment.statusId
                                                                                    === 1">
                                                                                <div class="p-fileupload-row">
                                                                                    <button pButton icon="fa fa-download" (click)="downloadFile(profileImg.attachment.name,
                                                                                        profileImg.attachment.content,
                                                                                        profileImg.attachment.location)" class="p-button-link p-px-0 p-py-0" label=""></button>
                                                                                    <ng-container *ngIf="profileImg.attachment &&
                                                                                            profileImg.attachment.content &&
                                                                                            profileImg.attachment.content.startsWith('data')
                                                                                            else localImage">
                                                                                        <img src="{{profileImg.attachment.content}}" width="100" alt="card" />
                                                                                    </ng-container>
                                                                                    <ng-template #localImage>
                                                                                        <img [src]="profileImg.attachment.location" width="100" alt="card" />
                                                                                    </ng-template>
                                                                                    <div>{{ profileImg.attachment.name }}
                                                                                    </div>
                                                                                    <div>{{ (profileImg.attachment.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                                                                    <div>
                                                                                        <button icon="pi pi-times" pButton (click)="removeProfileImg(i)" type="button" icon="pi pi-times"></button>
                                                                                    </div>
                                                                                </div>
                                                                            </ng-container>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </ng-template>
                                                            </p-fileUpload>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div class="p-field p-formgrid p-grid multiline" *ngIf="checkedFields.ContactDesignation">
                                            <div class="p-col-12 p-lg-6">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.ContactDesignation?.labelName }}
                                                    @if(checkedFields?.ContactDesignation.description){
                                                        <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                           pTooltip="{{checkedFields.ContactDesignation?.description}}"
                                                           tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <p-dropdown [options]="jobFunctions" formControlName="contactRoleId" name="contactRole" optionLabel="name" optionValue="id" placeholder="Select {{ checkedFields.ContactDesignation?.labelName }}" appendTo="body" filter="true">
                                                </p-dropdown>
                                            </div>
                                        </div>
                                        <div class="p-field p-formgrid p-grid multiline" *ngIf="checkedFields.ContactRoles">
                                            <div class="p-col-12 p-lg-6">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.ContactRoles?.labelName }}
                                                    @if(checkedFields?.ContactRoles.description){
                                                        <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                           pTooltip="{{checkedFields.ContactRoles?.description}}"
                                                           tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <p-multiSelect [options]="contactRoles" formControlName="contactRoles" name="contactRoles" optionValue="id"   optionLabel="name" placeholder="Select {{ checkedFields.ContactRoles?.labelName }}" appendTo="body" filter="true">
                                                </p-multiSelect>
                                            </div>
                                        </div>
                                        
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>

                    <p-tabView [(activeIndex)]="tabIndex">

                    <ng-container *ngFor="let section of templateSections; let i = index">
                        @if(section && section?.name === 'Account Information') {
                        <p-tabPanel [header]="section && section?.name" >
                            <div class="card">
                                <div class="p-field p-grid">
                                    <div class="p-col-6" *ngIf="checkedFields.AccountIDNo">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountIDNo?.labelName }} <span style="color: red;">*</span>
                                            @if(checkedFields?.AccountIDNo.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountIDNo?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="sequenceNumber" disabled/>
                                    </div>
                                    <div class="p-col-12 p-lg-6">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountName?.labelName }}
                                            @if(checkedFields?.AccountName.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountName?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="businessName" pattern="^[^:]*$" />
                                        <div class="p-mt-1" *ngIf="hasMaxLengthError('businessName')">
                                            <small class="p-invalid">
                                                Max 100 characters
                                            </small>
                                        </div>
                                        <div class="p-mt-1" *ngIf="hasPatternError('businessName')">
                                            <small class="p-invalid">
                                                Colon (:) is not allowed
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ParentAccount">
                                        <label for="parent" class="p-mb-2">
                                            {{ checkedFields.ParentAccount?.labelName }}
                                            @if(checkedFields?.ParentAccount.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.ParentAccount?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>

                                        <div class="association-name">
                                            <span (click)="openParentAcountDialog()" *ngIf="!selectedParentAccount" class="hyper-link"><strong class="association-name"><i class="pi pi-plus p-mr-2"></i> Select {{ checkedFields.ParentAccount?.labelName }}</strong></span>
                                            <span (click)="openParentAcountDialog()" *ngIf="selectedParentAccount" class="hyper-link">
                                                <strong class="association-name">
                                                    <i class="pi pi-pencil p-mr-2"></i>
                                                    <ng-container *ngIf="selectedParentAccount?.sequenceNumber">
                                                        {{ selectedParentAccount?.sequenceNumber }} -
                                                    </ng-container>
                                                    {{ selectedParentAccount?.businessName }}
                                                </strong>
                                                <i (click)="removeParentAccount()" class="pi pi-times p-ml-3"></i>
                                            </span>
                                        </div>

                                        <!-- <p-autoComplete #parent [suggestions]="parentSearch" [(ngModel)]="selectedParent" name="parent" placeholder="Search Parent Account..." field="name" [completeOnFocus]="true" (completeMethod)="searchParent($event)" id="parent" appendTo="body" dataKey="id"
                                            inputId="parent" name="selectedParent" [ngModelOptions]="{standalone: true}" (onSelect)="accountExistMsg = '';">
                                        </p-autoComplete> -->
                                        <small *ngIf="accountExistMsg?.length" class="p-invalid account-not-exists">
                                            {{ accountExistMsg }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.AccountOwner">
                                    <div class="p-col-12 p-lg-6">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountOwner?.labelName}} <span style="color: red;">*</span>
                                            @if(checkedFields?.AccountOwner.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountOwner?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="activeUsers" formControlName="ownerId" optionLabel="name" placeholder="Select Account Owner" [filter]="true" [filterBy]="'name'" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.AccountType || checkedFields.AccountNumber">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountType">
                                        <label for="accountTypes" class="p-mb-2">
                                            {{ checkedFields.AccountType?.labelName }}
                                            @if(checkedFields?.AccountType.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountType?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-multiSelect [options]="accountTypes" placeholder="Select Account Type(s)" formControlName="selectedAccountTypes" optionLabel="name" appendTo="body">
                                        </p-multiSelect>
                                    </div>

                                    <div class="p-col-6" *ngIf="checkedFields.AccountNumber">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountNumber?.labelName }}
                                            @if(checkedFields?.AccountNumber.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountNumber?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="accountNumber" />
                                        <div class="p-mt-1">
                                            <small *ngIf="hasMaxLengthError('accountNumber')" class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.Timezone || checkedFields.Currency">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Timezone">
                                        <label class="p-mb-2">
                                            {{ checkedFields.Timezone?.labelName }}
                                            @if(checkedFields?.Timezone.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Timezone?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="timezones" name="timezone" placeholder="Select Time Zone" inputId="timeZone" formControlName="timeZone" optionLabel="name" dataKey="id" appendTo="body">
                                        </p-dropdown>
                                    </div>

                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Currency">
                                        <label class="p-mb-2">
                                            {{ checkedFields.Currency?.labelName }}
                                            @if(checkedFields?.Currency.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Currency?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="currencies" id="currency" name="currency" optionLabel="name" placeholder="Select currency" appendTo="body" inputId="currency" formControlName="currencyUnit" dataKey="id" [filter]="true" [filterBy]="'name'" appendTo="body">
                                           
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.Tags">
                                    <div class="p-col-12">
                                        <label>Tags
                                            @if(checkedFields.Tags?.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Tags?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                            <span class="btnBars" (click)="addTag()"><i class="pi pi-plus"></i></span>
                                        </label>
                                        <ng-container *ngFor="let s of tags; let i = index">
                                            <p-tag  class="p-ml-2" [style]="{'background-color': s.color}">
                                                <div style="display: flex;padding: 2px;" (click)="removeTag(i)">
                                                    <div>{{s.name}}</div>
                                                    <div style="align-self: center;margin-left: 7px;cursor: pointer;"><i style="font-size: 8px;" class="pi pi-times"></i></div>
                                                </div>
                                            </p-tag>
                                        </ng-container>
                                    </div>
                                </div>

                                <app-shared-custom-fields-template [selectedCustomFields]="accountInfoCustomFields" [isSubmitted]="isSubmitted" [tabIndex]="0">
                                </app-shared-custom-fields-template>
                            </div>
                        </p-tabPanel>
                       }
                       @if(section && section?.name === 'Account Details'){
                        <p-tabPanel [header]="section && section?.name" >
                            <div class="card">
                                <div class="p-field p-grid" *ngIf="checkedFields.DoingBusinessas || checkedFields.TaxID">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.DoingBusinessas">
                                        <label class="p-mb-2">
                                            {{ checkedFields.DoingBusinessas?.labelName }}
                                            @if(checkedFields?.DoingBusinessas.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.DoingBusinessas?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="doingBusinessAs" />
                                        <div class="p-mt-1" *ngIf="hasMaxLengthError('doingBusinessAs')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                    </div>
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.TaxID">
                                        <label class="p-mb-2">
                                            {{ checkedFields.TaxID?.labelName }}
                                            @if(checkedFields?.TaxID.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.TaxID?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="taxId" />
                                        <div class="p-mt-1" *ngIf="hasMaxLengthError('taxId')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.NumberofEmployees || checkedFields.EstimatedAnnualRevenue">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.NumberofEmployees">
                                        <label class="p-mb-2">
                                            {{ checkedFields.NumberofEmployees?.labelName }}
                                            @if(checkedFields?.NumberofEmployees.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.NumberofEmployees?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="employeeCount" name="employeesRange" placeholder="Select Employee" inputId="employeesRange" formControlName="employeesRange" optionLabel="name" dataKey="id" appendTo="body">
                                        </p-dropdown>
                                    </div>

                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.EstimatedAnnualRevenue">
                                        <label for="annualRevenue" class="p-mb-2">
                                            {{ checkedFields.EstimatedAnnualRevenue?.labelName }}
                                            @if(checkedFields?.EstimatedAnnualRevenue.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.EstimatedAnnualRevenue?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="revenues" placeholder="Select Revenue" name="annualRevenue" inputId="annualRevenue" formControlName="annualRevenue" optionLabel="name" dataKey="id" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.OwnershipType || checkedFields.CurrentCategory">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.OwnershipType">
                                        <label class="p-mb-2">
                                            {{ checkedFields.OwnershipType?.labelName }}
                                            @if(checkedFields?.OwnershipType.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.OwnershipType?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="ownerships" name="ownerShipType" placeholder="Select ownership" inputId="ownership" formControlName="ownerShipType" optionLabel="name" dataKey="id" (onChange)="onChangeOwnership($event)" [filter]="true" filterBy="name" appendTo="body"></p-dropdown>
                                    </div>

                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.CurrentCategory">
                                        <label class="p-mb-2">
                                            {{ checkedFields.CurrentCategory?.labelName }}
                                            @if(checkedFields?.CurrentCategory.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.CurrentCategory?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="stages" name="businessClassification" placeholder="Select current category" inputId="businessClassification" formControlName="businessClassification" optionLabel="name" dataKey="id" [filter]="true" [filterBy]="'name'" appendTo="body" (onChange)="setStageOwnerAccordingToStage($event.value)"></p-dropdown>
                                    </div>
                                </div>

                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-lg-6" *ngIf="stageCommentEnable && crudType != 'add'">
                                        <label class="p-mb-2">
                                             Comment
                                        </label>
                                        <textarea pInputTextarea name="description" formControlName="comment" rows="2" class="w-100"></textarea>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.FoundedYear || checkedFields.Industry">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.FoundedYear">
                                        <label class="p-mb-2">
                                            {{ checkedFields.FoundedYear?.labelName }}
                                            @if(checkedFields?.FoundedYear.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.FoundedYear?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="foundedYear" />
                                        <div class="p-mt-1" *ngIf="hasMaxLengthError('foundedYear')">
                                            <small class="p-invalid">
                                                Max 15 characters
                                            </small>
                                        </div>
                                    </div>

                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Industry">
                                        <label class="p-mb-2">
                                            {{ checkedFields.Industry?.labelName }}
                                            @if(checkedFields?.Industry.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Industry?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="industries" formControlName="industry" placeholder="Select Industry" optionLabel="name" name="industry" dataKey="id" inputId="industry" [filter]="true" [filterBy]="'name'" appendTo="body"></p-dropdown>
                                    </div>
                                </div>

                                <div class="p-field p-grid p-mb-3" *ngIf="checkedFields.AccountEmail || checkedFields.AccountPhone">
                                    <div class="p-col-6" *ngIf="accountEmails.length">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountEmail?.labelName }}
                                            @if(checkedFields?.AccountEmail.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountEmail?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <div>
                                            <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                <i [pTooltip]="checkedFields.AccountEmail?.labelName" tooltipPosition="top"
                                                    class="pi pi-envelope">
                                                </i>
                                                <input pInputText type="email" [ngModelOptions]="{standalone: true}"
                                                    #accountemail="ngModel"
                                                    [accountId]="accountForm.value?.id" [leadId]="accountForm.value?.leadId"
                                                    asyncEmailValidator
                                                    pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                    [(ngModel)]="accountEmails[0].email.emailAddress" />
                                            </span>
                                        </div>
                                        <div class="p-mt-2" *ngIf="accountEmails.length">
                                            <div *ngIf="accountEmails[0].email?.emailAddress?.length > 50">
                                                <small class="p-invalid details-error">
                                                    Max 100 characters
                                                </small>
                                            </div>
                                            <div *ngIf="accountemail?.errors?.pattern">
                                                <small class="p-invalid details-error">
                                                    Invalid email format
                                                </small>
                                            </div>
                                            <div *ngIf="accountemail.errors?.emailExists">
                                                <small class="p-invalid details-error">
                                                    This email already added, please enter another email
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="p-col-6 p-pt-1" *ngIf="accountPhones.length">
                                        <div class="p-grid">
                                            <div class="p-col-12 p-lg-4">
                                                <label class="p-mb-2">Select Country</label>
                                                <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                    optionLabel="CountryName"
                                                    optionValue="CountryName"
                                                    [autoDisplayFirst]="false"
                                                    [(ngModel)]="accountPhones[0].phone.country"
                                                    placeholder="Select Country"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (onChange)="onCountrySelect($event, accountPhones[0], true)"
                                                    class="inline" appendTo="body">
                                                </p-dropdown>
                                            </div>
                                            <div class="p-col-12 p-lg-6">
                                                <label class="p-mb-2">
                                                    {{ checkedFields.AccountPhone?.labelName }}
                                                    @if(checkedFields?.AccountPhone.description){
                                                        <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                           pTooltip="{{checkedFields.AccountPhone?.description}}"
                                                           tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon">+{{accountPhones[0].phone.code}}</span>
                                                    <p-inputMask *ngIf="phoneNumberFormat && !accountPhones[0]?.phone?.maskingDisabled" [mask]="phoneNumberFormat" #accountphone="ngModel" [(ngModel)]="accountPhones[0].phone.number"
                                                    [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100"></p-inputMask>
                                                    <input *ngIf="!(phoneNumberFormat && !accountPhones[0]?.phone?.maskingDisabled)" pInputText type="text" #accountphone="ngModel" [ngModelOptions]="{standalone: true}"
                                                        [(ngModel)]="accountPhones[0].phone.number" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="p-pl-1 p-mt-1" *ngIf="accountPhones[0].phone.number | phoneValidation">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                        <div class="p-pl-1 p-mt-1" *ngIf="accountphone?.invalid">
                                            <small class="p-invalid">
                                                Invalid phone format
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-field p-grid p-mb-3">
                                    <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.AccountWebsite">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountWebsite?.labelName }}
                                            @if(checkedFields?.AccountWebsite.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountWebsite?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="accountWebsite.socialProfile.name">
                                        <div class="p-mt-2" *ngIf="accountWebsite?.socialProfile?.name?.length">
                                            <small class="p-invalid" *ngIf="accountWebsite?.socialProfile?.name?.length > 500">
                                                Max 500 characters
                                            </small>
                                        </div>
                                    </div>

                                    <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.AccountTwitter">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountTwitter?.labelName }}
                                            @if(checkedFields?.AccountTwitter.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountTwitter?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="accountTwitter.socialProfile.name">
                                        <div class="p-mt-2" *ngIf="accountTwitter?.socialProfile?.name?.length">
                                            <small class="p-invalid" *ngIf="accountTwitter?.socialProfile?.name?.length > 500">
                                                Max 500 characters
                                            </small>
                                        </div>
                                    </div>

                                    <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.AccountFacebook">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountFacebook?.labelName }}
                                            @if(checkedFields?.AccountFacebook.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountFacebook?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="accountFacebook.socialProfile.name">
                                        <div class="p-mt-2" *ngIf="accountFacebook?.socialProfile?.name?.length">
                                            <small class="p-invalid" *ngIf="accountFacebook?.socialProfile?.name?.length > 500">
                                                Max 500 characters
                                            </small>
                                        </div>
                                    </div>

                                    <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.AccountLinkedin">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountLinkedin?.labelName }}
                                            @if(checkedFields?.AccountLinkedin.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountLinkedin?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="accountLinkedin.socialProfile.name">
                                        <div class="p-mt-2" *ngIf="accountLinkedin?.socialProfile?.name?.length">
                                            <small class="p-invalid" *ngIf="accountLinkedin?.socialProfile?.name?.length > 500">
                                                Max 500 characters
                                            </small>
                                        </div>
                                    </div>

                                    <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.AccountInstagram">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountInstagram?.labelName }}
                                            @if(checkedFields?.AccountInstagram.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountInstagram?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="accountInstagram.socialProfile.name">
                                        <div class="p-mt-2" *ngIf="accountInstagram?.socialProfile?.name?.length">
                                            <small class="p-invalid" *ngIf="accountInstagram?.socialProfile?.name?.length > 500">
                                                Max 500 characters
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.SICCode || checkedFields.NAICSCode">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.SICCode">
                                        <label class="p-mb-2">
                                            {{ checkedFields.SICCode?.labelName }}
                                            @if(checkedFields?.SICCode.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.SICCode?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="sicCode" />
                                    </div>

                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.NAICSCode">
                                        <label class="p-mb-2">
                                            {{ checkedFields.NAICSCode?.labelName }}
                                            @if(checkedFields?.NAICSCode.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.NAICSCode?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <input pInputText type="text" formControlName="naicsCode" />
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.AccountSource || checkedFields.Rating">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountSource">
                                        <label class="p-mb-2">
                                            {{ checkedFields.AccountSource?.labelName }}
                                            @if(checkedFields?.AccountSource.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.AccountSource?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="accountSources" name="accountSource" placeholder="Select Account Source" inputId="source" formControlName="source" optionLabel="name" dataKey="id" [filter]="true" [filterBy]="'name'" appendTo="body"></p-dropdown>
                                    </div>
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Rating">
                                        <label class="p-mb-2">
                                            {{ checkedFields.Rating?.labelName }}
                                            @if(checkedFields?.Rating.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Rating?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="ratings" name="rating" placeholder="Select Rating" inputId="rating" formControlName="rating" optionLabel="name" dataKey="id" [filter]="true" [filterBy]="'name'" appendTo="body"></p-dropdown>
                                    </div>
                                </div>

                                <div class="p-field p-grid" *ngIf="checkedFields.Notes">
                                    <div class="p-col-12 p-lg-6">
                                        <label>
                                            {{ checkedFields.Notes?.labelName }}
                                            @if(checkedFields?.Notes.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Notes?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <textarea name="description" pInputTextarea type="text" formControlName="description" class="w-100"></textarea>
                                    </div>
                                </div>

                                <app-shared-custom-fields-template [selectedCustomFields]="accountDetailsCustomFields" [isSubmitted]="isSubmitted" [tabIndex]="1">
                                </app-shared-custom-fields-template>
                            </div>
                        </p-tabPanel>
                    }
                       @if(section && section.name === 'Address Details') {
                        <p-tabPanel [header]="section && section?.name" >
                            <app-lion-address-grid [fieldLabels]="labels_address" [addressList]="accountTempAddress" [countries]="countries"
                             [contactListAttn]="contactListAttn" [selectedObjectRecord]="selectedAccount" [allowEdit]="true"
                             [accountAddressTypes]="addressTypes" [moduleId]="accountModuleId"  [accountName]="accountForm.get('businessName').value"
                             [firstName]="formControl?.contact?.get('firstName').value"  [lastName]="formControl?.contact?.get('lastName').value"
                             [addressClasses]="addressClasses" mappingField="accountId" [checkedFields]="checkedFields" [overViewPage]="false" (onUpdateAddressList)="onUpdateAddressList($event)">
                            </app-lion-address-grid>
                        </p-tabPanel>
                       }
                    </ng-container>


                        <!-- Custom Section -->
                        <ng-container *ngFor="let customSection of customSections; let i = index">
                            <p-tabPanel *ngIf="customSection && customSection?.customFields?.length > 0" [header]="customSection?.name">
                                <app-shared-custom-fields-template
                                    [tabIndex]="(3+i)"
                                    [selectedCustomFields]="customSectionFields[i]"
                                    [isSubmitted]="isSubmitted">
                                </app-shared-custom-fields-template>
                            </p-tabPanel>
                        </ng-container>
                        <!-- End Custom Section -->

                    </p-tabView>
                </form>
            </div>
        </div>

        <ng-template #elseBlock style="font-size: 14px">
            {{ noTemplateMessage }}
        </ng-template>
    </ng-container>
    <ng-container *ngIf="displayView && viewAccountData && templateSections?.length>0">
        <ng-container>
            <div class="header">
                <h5>
                    {{ templateSections && templateSections[0]?.name }}
                </h5>
            </div>
            <div class="card">
                <div class="p-field p-grid p-mb-0">
                    <ng-container *ngIf="checkedFields.ContactID && viewAccountData.contactSequenceNumber">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactID?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactSequenceNumber }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.Title && viewAccountData.contactSalutation">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.Title?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactSalutation }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.FirstName && viewAccountData.contactFirstName">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.FirstName?.labelName }}
                                    <span style="color: red;">*</span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactFirstName }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.MiddleInitial && viewAccountData.contactMiddleName">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.MiddleInitial?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactMiddleName }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.LastName && viewAccountData.contactLastName">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.LastName?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactLastName }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.WorkEmail && viewAccountData.workEmailAddress">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.WorkEmail?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.workEmailAddress }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.HomeEmail && viewAccountData.homeEmailAddress">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.HomeEmail?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.homeEmailAddress }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.CE1 && viewAccountData.ce1EmailAddress">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.CE1?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.ce1EmailAddress }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.CE2 && viewAccountData.ce2EmailAddress">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.CE2?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.ce2EmailAddress }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.WorkPhone && viewAccountData.workPhone?.number">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.WorkPhone?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>{{ viewAccountData.workPhone.number | phoneNumber: viewAccountData.workPhone.countryCode }}</p>

                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.HomePhone && viewAccountData.homePhone?.number">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.HomePhone?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>{{ viewAccountData.homePhone.number | phoneNumber: viewAccountData.homePhone.countryCode }}</p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.MobilePhone && viewAccountData.mobilePhone?.number">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.MobilePhone?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>{{ viewAccountData.mobilePhone.number | phoneNumber: viewAccountData.mobilePhone.countryCode }}</p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.CP1 && viewAccountData.cp1Phone?.number">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.CP1?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>{{ viewAccountData.cp1Phone.number | phoneNumber: viewAccountData.cp1Phone.countryCode }}</p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.CP2 && viewAccountData.cp2Phone?.number">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.CP2?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>{{ viewAccountData.cp2Phone.number | phoneNumber: viewAccountData.cp2Phone.countryCode }}</p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ContactWebsite && viewAccountData.contactWebsite">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactWebsite?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactWebsite }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ContactTwitter && viewAccountData.contactTwitter">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactTwitter?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactTwitter }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ContactFacebook && viewAccountData.contactFacebook">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactFacebook?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactFacebook }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ContactLinkedin && viewAccountData.contactLinkedin">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactLinkedin?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactLinkedin }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ContactInstagram && viewAccountData.contactInstagram">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactInstagram?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.contactInstagram }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ProfileImage && viewAccountData.profileImages?.length">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ProfileImage?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <div *ngFor="let image of viewAccountData.profileImages" [pTooltip]="image.name" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                                <img [src]="image.downloadLink" width="100" alt="card" /> {{ image.name | shorten:15 }} ({{ image.sizeInKb + ' KB' }})
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ContactDesignation && viewAccountData.jobFunction">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactDesignation?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.jobFunction }} </p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="checkedFields.ContactRoles && viewAccountData.jobFunctions">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ContactRoles?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.jobFunctions }} </p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <ng-container>
            <div class="header">
                <h5>
                    {{ templateSections && templateSections[1]?.name }}
                </h5>
            </div>

            <div class="card">
                <div class="p-field p-grid p-mb-0">
                    <!-- <ng-container>
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.AccountIDNo?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.sequenceNumber }} </p>
                        </div>
                    </ng-container> -->
                    <ng-container>
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.AccountName?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>
                                <ng-container *ngIf="viewAccountData.sequenceNumber">
                                    {{ viewAccountData.sequenceNumber }} -
                                </ng-container>
                                {{ viewAccountData.businessName }}
                            </p>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.Status?.labelName||'Status' }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData?.status?.name }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.ParentAccount && viewAccountData.parentAccount">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.ParentAccount?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>
                                <ng-container *ngIf="viewAccountData?.parentAccountSequenceNumber">
                                    {{ viewAccountData.parentAccountSequenceNumber }} -
                                </ng-container>
                                {{ viewAccountData.parentAccount }}
                            </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.AccountOwner && viewAccountData.ownerName">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.AccountOwner?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.ownerName }} </p>
                        </div>
                    </ng-container>

                    <!-- <ng-container *ngIf="checkedFields.CurrentCategory && viewAccountData.currentStage">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.CurrentCategory?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.currentStage }} </p>
                        </div>
                    </ng-container> -->

                    <ng-container *ngIf="checkedFields.AccountType && viewAccountData.accountTypes">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.AccountType?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.accountTypes }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="checkedFields.AccountNumber && viewAccountData.accountNumber">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ checkedFields.AccountNumber?.labelName }} </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ viewAccountData.accountNumber }} </p>
                        </div>
                    </ng-container>
                </div>

                <ng-container *ngIf="showAccountInfoMore">
                    <div class="p-field p-grid p-mb-0">
                        <ng-container *ngIf="checkedFields.Timezone && viewAccountData.timezoneName">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Timezone?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.timezoneName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.Currency && viewAccountData.currency">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Currency?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4" *ngIf="viewAccountData.currency">
                                <p> {{ viewAccountData.currency }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.Tags && viewAccountData.tags">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Tags?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4" *ngIf="viewAccountData?.tags">
                                <span *ngFor="let tag of viewAccountData?.tags">
                                    <p-tag [value]="tag?.name" styleClass="p-ml-2" [style]="{'background-color': tag?.color}"></p-tag>
                                </span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="userAccessByTerritoryList?.length > 0">
                            <div class="p-col-12">
                                <p>
                                    <strong> Territory Information</strong>
                                </p>
                            </div>

                            <div class="p-col-4 p-md-2">

                            </div>
                            <div class="p-col-8 p-md-4">
                                <p-table [value]="userAccessByTerritoryList" *ngIf="userAccessByTerritoryList.length > 0">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th> Territory Name</th>
                                            <th> Assigned User</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-userAccess>
                                        <tr>
                                            <td>{{ userAccess.territotyName }}</td>
                                            <td>{{ userAccess.userName }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>

                <app-shared-custom-fields *ngIf="selectedAccount?.customAttributeValues" [isEdit]="false" [templateCustomFields]="templateSections[1]?.customFields" [customFieldValues]="selectedAccount?.customAttributeValues">
                </app-shared-custom-fields>

                <div class="p-field p-formgrid p-grid account-info-show-more">
                    <div class="p-col-12">
                        <button type="button" style="float: right;" pButton (click)="showAccountInfoMore = !showAccountInfoMore" label="{{ showAccountInfoMore ? 'Show Less' : 'Show More' }}" class="p-button-secondary">
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="showAccountInfoMore" class="p-mb-3">
                <div class="header">
                    <h5>
                        {{ templateSections && templateSections[2]?.name }}
                    </h5>
                </div>
                <div class="card">
                    <div class="p-field p-grid p-mb-0">
                        <ng-container *ngIf="checkedFields.DoingBusinessas && viewAccountData.doingBusinessAs">
                            <div class="p-col-4 p-md-2">
                                <p pTooltip="{{ checkedFields.DoingBusinessas?.labelName }}" tooltipPosition="top">
                                    <strong>
                                        {{ (checkedFields.DoingBusinessas?.labelName.length > 20 ) ?
                                        checkedFields.DoingBusinessas?.labelName.slice(0, 20) + '...'
                                        : checkedFields.DoingBusinessas?.labelName
                                        }}
                                    </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.doingBusinessAs }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.TaxID && viewAccountData.taxId">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.TaxID?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.taxId }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.NumberofEmployees && viewAccountData.employeesRangeName">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.NumberofEmployees?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.employeesRangeName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.EstimatedAnnualRevenue && viewAccountData.annualRevenueName">
                            <div class="p-col-4 p-md-2">
                                <p pTooltip="{{ checkedFields.EstimatedAnnualRevenue?.labelName }}" tooltipPosition="top">
                                    <strong>
                                        {{ (checkedFields.EstimatedAnnualRevenue?.labelName.length > 20 ) ?
                                        checkedFields.EstimatedAnnualRevenue?.labelName.slice(0, 20) + '...'
                                        : checkedFields.EstimatedAnnualRevenue?.labelName
                                        }}
                                    </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.annualRevenueName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.OwnershipType && viewAccountData.ownershipName">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.OwnershipType?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.ownershipName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.CurrentCategory && viewAccountData.currentStage">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong>
                                        {{ checkedFields.CurrentCategory?.labelName }}
                                    </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.stage }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.Prev && viewAccountData.previousStage">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Prev?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.previousStage }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.CategoryChangedBy && viewAccountData.stageChangedBy">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.CategoryChangedBy?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.stageChangedBy }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.CategoryChangedDate && viewAccountData.stageChangedDate">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.CategoryChangedDate?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.stageChangedDate | localDate: 'date'}} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.FoundedYear && viewAccountData.foundedYear">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.FoundedYear?.labelName }}</strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.foundedYear }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.Industry && viewAccountData.industryName">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Industry?.labelName }}</strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.industryName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.AccountEmail && viewAccountData.accountEmail">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong>
                                        {{ checkedFields.AccountEmail?.labelName }}
                                    </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <span>
                                    <i pTooltip="{{ checkedFields.AccountEmail?.labelName }}"
                                        tooltipPosition="top" class="pi pi-envelope">
                                    </i>
                                </span> {{ viewAccountData.accountEmail }}
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.AccountPhone && viewAccountData.accountPhone">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong>
                                        {{ checkedFields.AccountPhone?.labelName }}
                                    </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <span>
                                    <i pTooltip="{{ checkedFields.AccountPhone?.labelName }}"
                                        tooltipPosition="top" class="pi pi-mobile">
                                    </i>
                                </span> {{ viewAccountData.accountPhone | phoneNumber: viewAccountData.accountPhoneCode }}
                            </div>
                        </ng-container>

                        <ng-container>
                            <ng-container *ngIf="checkedFields.AccountWebsite && viewAccountData.accountWebsite">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.AccountWebsite?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewAccountData.accountWebsite }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.AccountTwitter && viewAccountData.accountTwitter">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.AccountTwitter?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewAccountData.accountTwitter }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.AccountFacebook && viewAccountData.accountFacebook">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.AccountFacebook?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewAccountData.accountFacebook }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.AccountLinkedin && viewAccountData.accountLinkedin">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.AccountLinkedin?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewAccountData.accountLinkedin }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.AccountInstagram && viewAccountData.accountInstagram">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.AccountInstagram?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewAccountData.accountInstagram }} </p>
                                </div>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.SICCode && viewAccountData.sicCode">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.SICCode?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.sicCode }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.NAICSCode && viewAccountData.naicsCode">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.NAICSCode?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.naicsCode }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.AccountSource && viewAccountData.sourceName">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.AccountSource?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.sourceName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.Rating && viewAccountData.ratingName">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Rating?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.ratingName }} </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="checkedFields.Notes && viewAccountData.description">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ checkedFields.Notes?.labelName }} </strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <p> {{ viewAccountData.description }} </p>
                            </div>
                        </ng-container>
                    </div>

                    <app-shared-custom-fields [isEdit]="false" [templateCustomFields]="templateSections[2]?.customFields" [customFieldValues]="selectedAccount?.customAttributeValues">
                    </app-shared-custom-fields>
                </div>


                <!-- Custom Section -->
                <ng-container *ngFor="let customSection of customSectionsForView; let i = index">
                    <ng-container *ngIf="customSection && customSection?.customFields?.length > 0">
                        <div class="header">
                            <h5>
                                {{ customSection?.name }}
                            </h5>
                        </div>
                        <div class="card">
                            <app-shared-custom-fields
                                [isEdit]="false"
                                [templateCustomFields]="customSection?.customFields"
                                [customFieldValues]="selectedAccount?.customAttributeValues">
                            </app-shared-custom-fields>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- End Custom Section -->

            </div>

            <app-lion-address-grid *ngIf="selectedAccount?.accountAddresses" [allowEdit]="false" [moduleId]="accountModuleId" [checkedFields]="checkedFields" [addressList]="selectedAccount.accountAddresses" [selectedObjectRecord]="selectedAccount" [accountAddressTypes]="addressTypes"
            [overViewPage]="false"  [addressClasses]="addressClasses" mappingField="accountId">
            </app-lion-address-grid>

            <app-shared-activities-timeline
                [objectId]="selectedAccount?.id"
                [selectedObject]="selectedAccount"
                objectType="Account"
                [hideRigthArrow]="true"
                [fromAccountView]="true"
                [hideEmailSyncIcon]="false"
                [isViewMode]="selectedAccount?.statusId != 1">
            </app-shared-activities-timeline>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="detailsLoadingFailed">
        <div class="card view-details-error-message">
            <span class="pi pi-exclamation-circle" style="font-size: 25px;"></span>
            <p>{{ detailsErrorMessage }}</p>
        </div>
    </ng-container>

    <p-footer>
        <button type="button" pButton (click)="closeModal.emit()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!displayView" type="submit" pButton (click)="verifyAndSubmitAccount(accountForm.getRawValue(),'view');" label="Save & View"></button>
        <button *ngIf="!displayView" type="submit" pButton (click)="verifyAndSubmitAccount(accountForm.getRawValue(),'save')" label="Save"></button>
    </p-footer>
</p-dialog>


<!-- Show tag list table -->
<ng-container *ngIf="displayAddTag">
    <app-assign-tag-dialog
        [showDialog]="displayAddTag"
        [selectedTags]="selectedValues"
        [tagList]="tagList"
        (assignedTag)="assignSelectedTags($event)"
        (addNewTag)="displayCreateTag = true"
        (closed)="displayAddTag = false">
    </app-assign-tag-dialog>
</ng-container>

<!-- Show add new tag dialog-->
<ng-container *ngIf="displayCreateTag">
    <app-add-tag-dialog
        [showDialog]="displayCreateTag"
        (clickSubmit)="createTag($event)"
        (closed)="displayCreateTag = false">
    </app-add-tag-dialog>
</ng-container>

<app-shared-manual-modal [displayPopup]="displayManualPopup"
    [colsList]="manualRuleColumnSetttings" [singleSelection]="true" [selectedObjectType]="selectedModule"
    [selectedTemplateType]="selectedChannel" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveParentAccount($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>
